// @noflow
import { fromJS, List } from 'immutable';

import { noop } from 'lodash/fp';

let trackersMap = fromJS({});

const createMiddleware = (satellite, myData) => store => next => action => {
    const { type, payload } = action;
    const handlers = trackersMap.get(type);
    const state = store.getState();
    const dispatch = store.dispatch;
    const params = [payload, state, dispatch];

    if (!satellite || !handlers) {
        return next(action);
    }

    handlers.forEach(handler => {
        const condition = handler.get('condition', () => true);
        const event = handler.get('event', noop)(...params);
        const values = handler.get('values', noop);

        if (!condition(...params)) {
            return;
        }

        satellite.data.customVars = {};
        const valuesToMap = values(...params) || {};
        Object.entries(valuesToMap).forEach(([k, v]) => satellite.setVar(k, v));
        satellite.track(event);
    });

    return next(action);
};

createMiddleware.registerTrackers = trackers =>
    trackers.forEach(tracker => {
        for (const [k, v] of Object.entries(tracker)) {
            const nextValue = trackersMap.get(k, List());
            trackersMap = trackersMap.set(k, nextValue.merge(fromJS(v)));
        }
    });

export default createMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/tracking/index.js